export default "__VITE_ASSET__zTNgZ_Zc__"